<!--
    @Author : Luo
    @Time   : 2025/1/17 11:32
-->
<template>
  <div class="client_main">

    <div class="client_type_tab">
      <div class="client_type_tab_con flex_center">
        <div v-for="i in tabData" :key="'n-t-' + i" :class="{ client_type_tab_info_act: tabIndex === i, client_type_tab_info: true, flex_center: true }" @click="selectTabHandle(i, 1)">
          <span>{{ consultTypeData[i] }}</span>
        </div>
      </div>
    </div>

    <div class="stage_nav">
      <div class="stage_nav_con flex_center">
        <div class="stage_nav_info text_ellipsis" style="margin-left: 40px">
          <span>咨询师</span>
        </div>
        <div v-if="isConsultTypeOther(tabIndex)" class="stage_nav_info text_ellipsis"><span>咨询师类型</span></div>
        <div class="stage_nav_info text_ellipsis"><span>工作时长</span></div>
        <div class="stage_nav_info text_ellipsis"><span>带教时长</span></div>
        <div class="stage_nav_info text_ellipsis"><span>调研</span></div>
        <div class="stage_nav_info text_ellipsis"><span>微信新增</span></div>
        <div class="stage_nav_info text_ellipsis"><span>咨询服务新增</span></div>
        <div class="stage_nav_info text_ellipsis"><span>保单整理</span></div>
        <div class="stage_nav_divider"></div>
        <div v-for="i in stageNavData" :key="'s-' + i.id" class="stage_nav_info stage_nav_detail text_ellipsis"><span>{{ i.name }}</span></div>
        <div class="stage_nav_divider" style="flex: auto"></div>
      </div>
    </div>

    <!-- 客户数据统计 -->
    <div class="user_main">
      <div class="user_main_con">
        <div v-for="i in userData" :key="'u-' + i.id" class="user_container">
          <div :class="{
            'user_info': true,
            'user_info_invaild': i.active === 0
          }" @click="i.hidden = !i.hidden">
            <div class="user_name" title="点击查看详情">
              <span style="color: #4C8BFF;font-size: 16px;font-weight: 400;display: inline-block;width: 40px;text-align: center" v-html="i.hidden ? '&and;' : '&or;'" />
              <span class="user_name_text">{{ i.name }}</span>
            </div>
            <div v-if="isConsultTypeOther(tabIndex)" class="user_total_val"><span v-html="i.consultType" /></div>
            <div class="user_total_val"><span v-html="i.totalWorkTime" /></div>
            <div class="user_total_val"><span v-html="i.totalCoachWorkTime" /></div>
            <div class="user_total_val user_total_inquire_val">
              <span v-html="i.totalInquireNew" />
              <svg-icon iconClass="icon_info" className="user_total_inquire_icon" @svgClick="catInquireDetail(i)"></svg-icon>
            </div>
            <div class="user_total_val"><span v-html="i.totalWxClient" /></div>
            <div class="user_total_val"><span v-html="i.totalService" /></div>
            <div class="user_total_val"><span v-html="i.totalPolicy" /></div>
            <div class="stage_nav_divider"></div>
            <div class="user_total_con">
              <div v-for="s in stageNavData" :key="'u-' + i.id + '-n-s-' + s.id" class="user_total_stage_con user_total_val">
                <span>{{ getTotalStage(s.id, i.totalStage) }}</span>
              </div>
            </div>
          </div>

          <!-- 客户阶段数据 -->
          <div class="user_session" v-if="i.hidden">
            <div class="user_session_con">
              <div class="user_session_table">
                <table>
                  <thead>
                    <tr>
                      <th class="top_fixed left_fixed">来源</th>
                      <th class="top_fixed left_fixed">居住/户籍</th>
                      <th class="top_fixed left_fixed">姓名</th>
                      <th class="top_fixed left_fixed">状态</th>
                      <th class="top_fixed" v-for="s in stageData" :key="'u-' + i.id + '-m-s-' + s.id">
                        {{ s.name }}
                        <br>
                        [
                        {{ getTimeFormat(s.duration) }}*{{ getTotalStage(s.id, i.totalStage) }}
                        =
                        <strong>{{ getTimeFormat(getTotalStage(s.id, i.totalStage) * s.duration) }}</strong>
                        ]
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="c in i.clientSession" :key="'u-' + i.id + '-c-' + c.id">
                      <td :class="'text_ellipsis left_fixed' + (c.select ? ' user_session_select' : '')" :title="c.originName">
                        <div class="user_session_option">
                          <span class="user_session_option_tab">{{ c.belongName }}</span>
                          <!-- <span>{{ c.originName }}</span> -->
                        </div>
                      </td>
                      <td :class="'text_ellipsis left_fixed' + (c.select ? ' user_session_select' : '')" :title="cityData[getCityKey(c.social)] + '/' + cityData[getCityKey(c.resident)]">{{ cityData[getCityKey(c.social)] }}/{{ cityData[getCityKey(c.resident)] }}</td>
                      <td :class="'text_ellipsis left_fixed' + (c.select ? ' user_session_select' : '')" :title="getClientName(c) + getRelationInfo(c.relationData) + getTrafficInfo(c.traffic) + getParticipantInfo(c.participant)">
                        <div class="user_session_name">
                          <div><span>{{ c.name }}</span></div>
                          <div v-if="c.history" class="client_renew_tag"><span>二开</span></div>
                        </div>
                      </td>
                      <td :class="'text_ellipsis left_fixed' + (c.select ? ' user_session_select' : '')" :title="getClientStatusVal(c.stage).status">
                        <i :class="'user_session_info_tag user_session_info_tag_' + getClientStatusVal(c.stage).tag" />
                        {{ getClientStatusVal(c.stage).status }}
                      </td>
                      <td v-for="s in c.stages" :key="'u-' + i.id + '-i-' + s.id" :class="'user_session_stage text_ellipsis' + (s.select ? ' user_session_select' : '')">
                        <span :title="s.content">
                          {{ setDateType(s.makeAt * 1000) }}&nbsp;&nbsp;{{ setDateSecond(s.makeAt * 1000) }}
                        </span>
                        <div class="user_session_stage_tag">
                          <span v-if="getStageStatusVal(s.status, s.makeAt).val" :style="{ backgroundColor: getStageStatusVal(s.status, s.makeAt).bgColor, borderColor: getStageStatusVal(s.status, s.makeAt).color, color: getStageStatusVal(s.status, s.makeAt).color }">{{ getStageStatusVal(s.status, s.makeAt).val }}</span>
                          <span v-if="isCoach(s)" :style="{ borderColor: '#4C8BFF', color: 'rgba(76, 139, 255, 1)' }" :title="getCoachMember(s.coachTeamMember, c.name)">{{ isCoach(s) ? '带教' : '' }}</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setDateType, setDateSecond } from '@/components/common/common_js'
import { getCityKey } from './common'

import { getClientStatusVal, getStageStatusVal, isConsultTypeOther, setNeedStage, isCoach } from './index-client'

export default {
  name: 'accountAnalysisPage',
  components: {},
  props: {
    user: {
      type: Array,
      default: () => []
    },
    stageData: {
      type: Array,
      default: () => []
    },
    cityData: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Array,
      default: () => []
    },
    tabData: {
      type: Array,
      default: () => []
    },
    tabIndex: {
      type: String,
      default: ''
    },
    consultTypeData: {
      type: Object,
      default: () => {}
    },
    vaild: {
      type: Number,
      default: 1
    }
  },
  computed: {
    stageNavData: function () {
      const that = this
      const tempNeedStage = setNeedStage()
      const tempData = that.stageData.filter(i => tempNeedStage.includes(i.sort))

      console.log('data-', tempData)
      return tempData
    }
  },
  data () {
    return {
      setDateType: setDateType,
      setDateSecond: setDateSecond,
      getClientStatusVal: getClientStatusVal,
      getStageStatusVal: getStageStatusVal,
      getCityKey: getCityKey,
      isConsultTypeOther: isConsultTypeOther,
      isCoach: isCoach
    }
  },
  methods: {
    selectTabHandle: function (i) { this.$emit('update', i) },
    catInquireDetail: function (i) { this.$emit('cat', i) },
    getTimeFormat: function (v) { return (v / 60).toFixed(2) + 'h' },
    getClientName: function (v) { return '【姓名/昵称：' + v.name + '/' + v.nickname + '】' },
    getRelationInfo: function (v) { return '【推荐人：' + (v && v[0] ? v[0].name : '无') + '】' },
    getTotalStage: function (id, data) { return data[id] ? data[id].length : 0 },
    getTrafficInfo: function (v) {
      const that = this
      const tempData = that.user
      let tempName = '无'
      for (const i of tempData) {
        if (v && v.includes(i.id)) tempName = i.name
      }

      return '【引流人：' + tempName + '】'
    },
    getParticipantInfo: function (v) {
      const that = this
      const tempData = that.user
      let tempName = '无'
      for (const i of tempData) {
        if (v && v.includes(i.id)) tempName = i.name
      }

      return '【共同展业人：' + tempName + '】'
    },
    getClientBelongColor: function (v) {
      switch (v) {
        case '柏翌推荐':
          return '#4C8BFF'
        case '自有客户':
          return '#333333'
        default:
          return '#333333'
      }
    },
    getCoachMember: function (v, n) {
      const that = this
      const tempData = that.user
      let tempName = ''
      for (const i of tempData) {
        if (v.includes(i.id)) tempName += (tempName ? ',' : '') + i.name
      }

      return tempName
    }
  },
  mounted () {}
}
</script>

<style scoped>
.top_fixed {position: sticky;top: 0;z-index: 9}
.left_fixed {position: sticky;left: 0;z-index: 9}

.client_type_tab_con {justify-content: flex-start;padding: 20px 0 0;--el-tab-act: rgba(51, 139, 255, 1)}
.client_type_tab_info {min-width: 80px;height: 32px;padding: 0 19px;cursor: pointer;background-color: rgba(246, 246, 246, 1);border-radius: 16px}
.client_type_tab_info_act {background-color: var(--el-tab-act);transition: all .1s}
.client_type_tab_info + .client_type_tab_info {margin-left: 20px}
.client_type_tab_info span {font-weight: 500;font-size: 14px;color: rgba(144, 144, 144, 1)}
.client_type_tab_info:hover span {color: var(--el-tab-act)}
.client_type_tab_info.client_type_tab_info_act span {color: #FFFFFF}

.stage_nav {margin: 26px 0 0 0;background-color: #F8F8F9;border-top: 1px solid #EBEBEB;border-bottom: 1px solid #EBEBEB;}
.stage_nav_con {justify-content: flex-start}
.stage_nav_info {line-height: 50px;font-size: 14px;color: #666}
.stage_container + .stage_container {margin-left: 24px}
.stage_container span {font-size: 20px;font-weight: bold;color: rgba(48, 48, 48, 1);line-height: 48px}
.stage_nav_divider {height: 50px;width: 20px}
/* .stage_nav_divider,
.stage_nav_con .stage_nav_info.stage_nav_detail {background-color: rgba(200, 200, 200, 1)} */
.user_container .stage_nav_divider {background-color: unset}

.client_header_con {display: flex;justify-content: space-between}
.client_header_l {color: #303030;font-size: 24px;font-weight: bold}
.client_header_date {margin: 0 16px}
.client_header_date input {border: 1px solid #DBDBDB;border-radius: 4px;height: 32px;width: 200px;outline: none;padding: 0 15px;font-size: 14px}
.client_header_btn button {width: 80px;height: 32px;background: #4C8BFF;border-radius: 4px;outline: none;border: 1px solid #4C8BFF;font-size: 12px;color: #FFFFFF}
.client_renew_tag {margin-top: 4px;display: flex}
.client_renew_tag span {font-size: 12px;padding: 3px 7px;border-radius: 3px;background-color: #E4F0FF;color: rgb(76, 139, 255)}

.user_total_val {display: flex;align-items: center}
.user_total_val span {color: rgba(96, 96, 96, 1);font-size: 16px;font-weight: bold}

.stage_nav_con .stage_nav_info:nth-of-type(1),
.user_total_con .user_total_stage_con:nth-of-type(1),
.user_total_val:nth-of-type(1) {min-width: 134px}
.user_name {min-width: 174px}
.stage_nav_con .stage_nav_info:nth-of-type(2),
.user_total_con .user_total_stage_con:nth-of-type(2),
.user_total_val:nth-of-type(2) {min-width: 134px}
.stage_nav_con .stage_nav_info,
.user_total_con .user_total_stage_con,
.user_total_val {min-width: 110px}
.stage_nav_con .stage_nav_info.stage_nav_detail,
.user_total_con .user_total_stage_con {min-width: 130px}
.stage_nav_detail span {font-weight: bold}

.user_info {display: flex}
.user_name {display: flex;align-items: center}
.user_name span.user_name_text {display: inline-block;max-width: 100px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap}
.user_name span {font-size: 14px;font-weight: bold;color: #282828;line-height: 46px}
.user_total_stage_con span {font-size: 14px;line-height: 46px}
.user_main {width: 100%;height: 60vh;overflow: auto}
.user_container {border-bottom: 1px solid #EBEBEB;overflow: hidden}
.user_container:hover {background-color: RGBA(245, 249, 254, 1)}
.user_total_con {display: flex;align-items: center}

.user_session {background-color: #F8F8F9}
.user_session_table {max-height: 400px;overflow: auto;margin-left: 38px}
.user_session_table table {border-collapse: collapse;table-layout: fixed}
.user_session_table thead th:nth-child(1),
.user_session_table thead th:nth-child(2),
.user_session_table thead th:nth-child(3),
.user_session_table thead th:nth-child(4) {z-index: 15}
.user_session_table thead th {background-color: #f8f8f9}
.user_session_table tbody td {background-color: #fff}
.user_session_table thead th, .user_session_table tbody td {min-width: 200px;max-width: 200px}
.user_session_table thead th:nth-child(1), .user_session_table tbody td:nth-child(1) {min-width: 110px;max-width: 110px;padding-left: 17px}
.user_session_table thead th:nth-child(2), .user_session_table tbody td:nth-child(2) {min-width: 110px;max-width: 110px;left: 127px}
.user_session_table thead th:nth-child(3), .user_session_table tbody td:nth-child(3) {min-width: 110px;max-width: 110px;left: 237px}
.user_session_table thead th:nth-child(4), .user_session_table tbody td:nth-child(4) {min-width: 90px;max-width: 90px;left: 347px;border-right: 1px solid #ebebeb}
.user_session_table thead th:nth-child(5), .user_session_table tbody td:nth-child(5) {padding-left: 20px}
.user_session_table tbody {background: #fff}
.user_session_table thead tr {line-height: 50px;height: 50px}
.user_session_table thead tr th {line-height: 24px}
.user_session_table tbody tr {line-height: 52px;height: 52px}
.user_session_table tr {font-size: 14px;border-bottom: 1px solid #ebebeb}
.user_session_table thead th {color: #666;padding: 0 10px}
.user_session_table tbody td {color: #282828;padding: 0 10px}
.user_session_stage {line-height: 1}
.user_session_stage_tag {display: flex;align-items: center;margin-top: 6px}
.user_session_stage_tag span {display: inline-block;padding: 2px 7px;border-radius: 3px;font-size: 12px;font-weight: 400;border: 1px solid}
.user_session_stage_tag span + span {margin-left: 10px}
.user_session_name {display: flex;justify-content: center;flex-flow: column}

.user_total_inquire_val {cursor: pointer}
.user_total_val.user_total_inquire_val:hover span {color: rgba(76, 139, 255, 1)}
.user_total_val.user_total_inquire_val:hover >>> .user_total_inquire_icon {fill: rgba(76, 139, 255, 1)}
.user_total_val.user_total_inquire_val >>> .user_total_inquire_icon {width: 14px;height: 14px}
.user_total_val.user_total_inquire_val >>> span.select_down {margin-left: 2px;font-size: 14px;height: 14px}

tr td.user_session_select {background-color: rgb(241, 250, 235)}
.user_session_info_tag {display: inline-block;width: 8px;height: 8px;border-radius: 50%}
.user_session_info_tag_invaild {background-color: #EB1B1B}
.user_session_info_tag_success {background-color: #12BF26}
.user_session_info_tag_planning {background-color: #4C8BFF}
.user_session_option {display: flex;align-items: center;--el-tag-color: #000000}
.user_session_option_tab {display: inline-block;width: 18px;border-radius: 2px;text-align: center;color: var(--el-tag-color);font-size: 12px}

.user_info_invaild.user_info {background-color: rgba(238, 238, 238, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-client/index-client.vue